module.exports = __webpack_public_path__ + "img/qw.52df0357.png";